const JobStatusType = {
  FAILED: { value: "Failed", label: "Failed" },
  INPROGRESS: { value: "InProgress", label: "In Progress" },
  COMPLETE: { value: "Complete", label: "Complete" },
  CANCELLED: { value: "Cancelled", label: "Cancelled" },
};

export const getJobStatusLabel = status => {
  const foundJobStatus = Object.values(JobStatusType).find(
    jobStatus => jobStatus.value.toLowerCase() === status.toLowerCase(),
  );
  return foundJobStatus ? foundJobStatus.label : status;
};

export const isJobStatusComplete = status => status.toLowerCase() === JobStatusType.COMPLETE.value.toLowerCase();

export const isJobStatusFailed = status => status.toLowerCase() === JobStatusType.FAILED.value.toLowerCase();

export const isJobStatusInProgress = status => status.toLowerCase() === JobStatusType.INPROGRESS.value.toLowerCase();

export const isJobStatusCancelled = status => status.toLowerCase() === JobStatusType.CANCELLED.value.toLowerCase();

export const isJobStatusFailedOrCompleteOrCancelled = status => isJobStatusFailed(status)
  || isJobStatusComplete(status)
  || isJobStatusCancelled(status);

export const isJobStatusFailedOrCancelled = status => isJobStatusFailed(status) || isJobStatusCancelled(status);
